import { IAlbum } from './models';
export const PhotoLibrary: Array<IAlbum> = [
  {
    album: `A Special Clinic`,
    catalog: `projects`,
    statement: ["It’s 06:30 on a chilly winter morning in Hanoi, Associate Professor Phạm Thị Xuân Vân (91) climbs onto a moto-taxi and head to the Pet Acupuncture Association’s Community Veterinary Clinic—a routine she has maintained for the past decade or so.","","In 2012, in affiliation with the Vietnam Academy of Agriculture, Grandma Vân established the Pet Acupuncture Association’s Community Veterinary Clinic. Its mission? To provide treatment for paralyzed cats and dogs using traditional acupuncture techniques. Additionally, the clinic serves as a training ground for students from the academy’s Veterinarian department, allowing them to gain hands-on experience as part of their graduation thesis. Thanks to the support from the academy and generous sponsors, the clinic operates under a free treatment policy. Owners would only need to cover minimal expenses for food, lodging, and medication during weeks or even months of acupuncture therapy. The clinic’s dedicated staff includes both students from the department as well as alumni who volunteer their support.","","As a member of the Vietnam Academy of Agriculture’s inaugural cohort of lecturers, Vân pursued her veterinary studies at the South China Agricultural University from 1953 to 1958. During her time there, she immersed herself in the research of animal acupuncture techniques. Upon returning home, she pushed for its integration as a core practice within the Veterinarian Department. Today, after six decades, she stands as Vietnam’s foremost pet acupuncturist, having mentored many generations of practicing veterinarians. Today Grandma Vân's love for animals and commitment to the students continue to fuel her ongoing research and work."],
    images: [
      require(`@/assets/albums/projects/A Special Clinic/01.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/02.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/03.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/04.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/05.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/06.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/07.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/08.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/09.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/10.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/11.jpg`),
      require(`@/assets/albums/projects/A Special Clinic/12.jpg`),
    ]
  },
  {
    album: `Banyan Trees`,
    catalog: `projects`,
    statement: [""],
    images: [
      require(`@/assets/albums/projects/Banyan Trees/01.jpg`),
      require(`@/assets/albums/projects/Banyan Trees/02.jpg`),
      require(`@/assets/albums/projects/Banyan Trees/03.jpg`),
      require(`@/assets/albums/projects/Banyan Trees/04.jpg`),
      require(`@/assets/albums/projects/Banyan Trees/05.jpg`),
      require(`@/assets/albums/projects/Banyan Trees/06.jpg`),
      require(`@/assets/albums/projects/Banyan Trees/07.jpg`),
      require(`@/assets/albums/projects/Banyan Trees/08.jpg`),
      require(`@/assets/albums/projects/Banyan Trees/09.jpg`),
    ]
  },
  {
    album: `By The Water`,
    catalog: `projects`,
    statement: [""],
    images: [
      require(`@/assets/albums/projects/By The Water/01.jpg`),
      require(`@/assets/albums/projects/By The Water/02.jpg`),
      require(`@/assets/albums/projects/By The Water/03.jpg`),
      require(`@/assets/albums/projects/By The Water/04.jpg`),
      require(`@/assets/albums/projects/By The Water/05.jpg`),
      require(`@/assets/albums/projects/By The Water/06.jpg`),
      require(`@/assets/albums/projects/By The Water/07.jpg`),
      require(`@/assets/albums/projects/By The Water/08.jpg`),
      require(`@/assets/albums/projects/By The Water/09.jpg`),
      require(`@/assets/albums/projects/By The Water/10.jpg`),
      require(`@/assets/albums/projects/By The Water/11.jpg`),
      require(`@/assets/albums/projects/By The Water/12.jpg`),
      require(`@/assets/albums/projects/By The Water/13.jpg`),
      require(`@/assets/albums/projects/By The Water/14.jpg`),
      require(`@/assets/albums/projects/By The Water/15.jpg`),
      require(`@/assets/albums/projects/By The Water/16.jpg`),
    ]
  },
  {
    album: `Controversial Cuisine`,
    catalog: `projects`,
    statement: [""],
    images: [
      require(`@/assets/albums/projects/Controversial Cuisine/01.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/02.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/03.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/04.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/05.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/06.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/07.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/08.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/09.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/10.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/11.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/12.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/13.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/14.jpg`),
      require(`@/assets/albums/projects/Controversial Cuisine/15.jpg`),
    ]
  },
  {
    album: `Future Perfect`,
    catalog: `projects`,
    statement: ["An impending change in marital status sparked my interest in documenting the popup wedding tents and flower gates that I would run into randomly on the streets of Hanoi. These temporary, copy-pasted structures are moved and installed door-to-door, marking the beginning to a supposedly long and happy marriage. By omitting the event and photographing the scenes before the fact, I attempted to use the night's silence and stillness and convey the sense of tension prior to the big day.",""],
    images: [
      require(`@/assets/albums/projects/Future Perfect/01.jpg`),
      require(`@/assets/albums/projects/Future Perfect/02.jpg`),
      require(`@/assets/albums/projects/Future Perfect/03.jpg`),
      require(`@/assets/albums/projects/Future Perfect/04.jpg`),
      require(`@/assets/albums/projects/Future Perfect/05.jpg`),
      require(`@/assets/albums/projects/Future Perfect/06.jpg`),
      require(`@/assets/albums/projects/Future Perfect/07.jpg`),
      require(`@/assets/albums/projects/Future Perfect/08.jpg`),
      require(`@/assets/albums/projects/Future Perfect/09.jpg`),
      require(`@/assets/albums/projects/Future Perfect/10.jpg`),
      require(`@/assets/albums/projects/Future Perfect/11.jpg`),
      require(`@/assets/albums/projects/Future Perfect/12.jpg`),
      require(`@/assets/albums/projects/Future Perfect/13.jpg`),
      require(`@/assets/albums/projects/Future Perfect/14.jpg`),
    ]
  },
  {
    album: `Timbre of a Northern land`,
    catalog: `projects`,
    statement: ["Pham Phao is one of many parishes in Hai Hau district, Nam Dinh—a province in Vietnam renowned for its dense Catholic population. This unique region, where Eastern traditions blend seamlessly with Western musical influences, is characterized by the presence of brass bands in nearly every village. Pham Phao stands out as the sole location in the entire country where workshops and artisans are dedicated not only to repairing but also to manufacturing brass instruments, earning it the title \"The Capital of Vietnam’s Brass Instruments.\" During the day, villagers work as farmers and craftsmen; by night, they gather to rehearse and perform. Their repertoire extends beyond traditional worship music, featuring brass choir renditions of Vietnamese revolutionary ballads that resonate through the quaint alleys. Trumpets and saxophones have become a source of joy and livelihood for the residents of this quintessential Northern Vietnamese village."],
    images: [
      require(`@/assets/albums/projects/Timbre of a Northern land/01.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/02.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/03.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/04.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/05.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/06.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/07.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/08.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/09.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/10.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/11.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/12.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/13.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/14.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/15.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/16.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/17.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/18.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/19.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/20.jpg`),
      require(`@/assets/albums/projects/Timbre of a Northern land/21.jpg`),
    ]
  },
  {
    album: `Until Next Time`,
    catalog: `projects`,
    statement: ["We all knew what was coming. Every sign was pointing in the same direction - the fortune-telling from a monk, medical diagnoses, little omens in the forms of burnt pots and broken glasses. All the preparations for one’s passing, both logistic and mental, rendered my family and me numb to life around us. Yet it kept happening, again and again.\r","\r","\r","Every funeral was the same - there would be loads of paperwork to process on top of the grand decision of when and where the ceremony would take place. Not knowing what to do, I just waited on standby to run trivial errands while the adults scrambled to prepare for one’s transition to the afterlife. What I felt then, more prevalent than grief, was a sense of boredom. I just wanted time to pass by faster, so we were done with it and I could go home. \r","\r","\r","With the clarity of hindsight, I realize I was using the camera as a shield all along. Looking through a fogged viewfinder and constantly pressing the shutter distracted me from whatever was taking place. For a while, these photographs of my family in mourning were stacked away in a box. Together with domestic details, they are reminders of uncertainty and impending loss as we return to everyday life. Home offers comfort, but nothing stays the same. \r","\r","\r","By displaying the entirety of these images in chronological order, I’m no longer judging them by aesthetic or content, but as equal physical reproductions of memories. The memories live on as we process grief - each in our own ways, making amends with our broken promises and words left unsaid."],
    images: [
      require(`@/assets/albums/projects/Until Next Time/01.jpg`),
      require(`@/assets/albums/projects/Until Next Time/02.jpg`),
      require(`@/assets/albums/projects/Until Next Time/03.jpg`),
      require(`@/assets/albums/projects/Until Next Time/04.jpg`),
      require(`@/assets/albums/projects/Until Next Time/05.jpg`),
      require(`@/assets/albums/projects/Until Next Time/06.jpg`),
      require(`@/assets/albums/projects/Until Next Time/07.jpg`),
      require(`@/assets/albums/projects/Until Next Time/08.jpg`),
      require(`@/assets/albums/projects/Until Next Time/09.jpg`),
      require(`@/assets/albums/projects/Until Next Time/10.jpg`),
      require(`@/assets/albums/projects/Until Next Time/11.jpg`),
      require(`@/assets/albums/projects/Until Next Time/12.jpg`),
      require(`@/assets/albums/projects/Until Next Time/13.jpg`),
      require(`@/assets/albums/projects/Until Next Time/14.jpg`),
      require(`@/assets/albums/projects/Until Next Time/15.jpg`),
      require(`@/assets/albums/projects/Until Next Time/16.jpg`),
      require(`@/assets/albums/projects/Until Next Time/17.jpg`),
      require(`@/assets/albums/projects/Until Next Time/18.jpg`),
      require(`@/assets/albums/projects/Until Next Time/19.jpg`),
      require(`@/assets/albums/projects/Until Next Time/20.jpg`),
      require(`@/assets/albums/projects/Until Next Time/21.jpg`),
    ]
  },
  {
    album: `Events & Editorial`,
    catalog: `commissions`,
    statement: [""],
    images: [
      require(`@/assets/albums/commissions/Events & Editorial/01.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/02.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/03.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/04.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/05.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/06.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/07.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/08.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/09.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/10.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/11.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/12.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/13.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/14.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/15.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/16.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/17.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/18.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/19.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/20.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/21.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/22.jpg`),
      require(`@/assets/albums/commissions/Events & Editorial/23.jpg`),
    ]
  },
  {
    album: `F&B`,
    catalog: `commissions`,
    statement: [""],
    images: [
      require(`@/assets/albums/commissions/F&B/01.jpg`),
      require(`@/assets/albums/commissions/F&B/02.jpg`),
      require(`@/assets/albums/commissions/F&B/03.jpg`),
      require(`@/assets/albums/commissions/F&B/04.jpg`),
      require(`@/assets/albums/commissions/F&B/07.jpg`),
      require(`@/assets/albums/commissions/F&B/08.jpg`),
      require(`@/assets/albums/commissions/F&B/09.jpg`),
      require(`@/assets/albums/commissions/F&B/10.jpg`),
      require(`@/assets/albums/commissions/F&B/5.jpg`),
      require(`@/assets/albums/commissions/F&B/6.jpg`),
    ]
  },
  {
    album: `Portraits`,
    catalog: `commissions`,
    statement: [""],
    images: [
      require(`@/assets/albums/commissions/Portraits/01.jpg`),
      require(`@/assets/albums/commissions/Portraits/02.jpg`),
      require(`@/assets/albums/commissions/Portraits/03.jpg`),
      require(`@/assets/albums/commissions/Portraits/04.jpg`),
      require(`@/assets/albums/commissions/Portraits/05.jpg`),
      require(`@/assets/albums/commissions/Portraits/06.jpg`),
      require(`@/assets/albums/commissions/Portraits/07.jpg`),
      require(`@/assets/albums/commissions/Portraits/08.jpg`),
      require(`@/assets/albums/commissions/Portraits/09.jpg`),
      require(`@/assets/albums/commissions/Portraits/10.jpg`),
      require(`@/assets/albums/commissions/Portraits/11.jpg`),
      require(`@/assets/albums/commissions/Portraits/14.jpg`),
      require(`@/assets/albums/commissions/Portraits/15.jpg`),
      require(`@/assets/albums/commissions/Portraits/16.jpg`),
    ]
  },
  {
    album: `Spaces`,
    catalog: `commissions`,
    statement: [""],
    images: [
      require(`@/assets/albums/commissions/Spaces/01.jpg`),
      require(`@/assets/albums/commissions/Spaces/02.jpg`),
      require(`@/assets/albums/commissions/Spaces/03.jpg`),
      require(`@/assets/albums/commissions/Spaces/04.jpg`),
      require(`@/assets/albums/commissions/Spaces/05.jpg`),
      require(`@/assets/albums/commissions/Spaces/06.jpg`),
      require(`@/assets/albums/commissions/Spaces/07.jpg`),
      require(`@/assets/albums/commissions/Spaces/08.jpg`),
      require(`@/assets/albums/commissions/Spaces/09.jpg`),
      require(`@/assets/albums/commissions/Spaces/10.jpg`),
      require(`@/assets/albums/commissions/Spaces/11.jpg`),
      require(`@/assets/albums/commissions/Spaces/12.jpg`),
      require(`@/assets/albums/commissions/Spaces/13.jpg`),
      require(`@/assets/albums/commissions/Spaces/14.jpg`),
      require(`@/assets/albums/commissions/Spaces/15.jpg`),
      require(`@/assets/albums/commissions/Spaces/16.jpg`),
      require(`@/assets/albums/commissions/Spaces/17.jpg`),
      require(`@/assets/albums/commissions/Spaces/18.jpg`),
      require(`@/assets/albums/commissions/Spaces/19.jpg`),
    ]
  },
];
